"use strict";

class Timeline {
    constructor() {
        const totalAnimationDuration = 1200;
        const animationDelay = 50;
        const main = document.querySelector(".timeline-page body main");
        const mainActiveCls = "timeline-page--active";

        if (!main) return;

        // function to animate the h1 text
        function setH1Anim(el) {
            const text = el.innerText;
            el.innerText = "";
            let delay = 0;

            for (const [i, char] of [...text].entries()) {
                const span = document.createElement("span");
                if (char === " ") {
                    span.setAttribute("data-space", "true");
                } else if (i === 0) {
                    span.style.animationDuration = `${totalAnimationDuration}ms`;
                } else {
                    span.style.animationDuration = `${
                        totalAnimationDuration - delay
                    }ms`;
                    span.style.animationDelay = `${delay}ms`;
                }
                delay += animationDelay;
                span.textContent = char;
                el.insertAdjacentElement("beforeend", span);
            }
        }

        // add animations to h1 lines
        setH1Anim(document.querySelector("h1 .line--1"));
        setH1Anim(document.querySelector("h1 .line--2"));

        // functionality to start the timeline
        document
            .getElementById("timeline-start")
            .addEventListener("click", (e) => {
                document.documentElement.classList.add(mainActiveCls);
            });

        // scroll vertical on wheel down/up
        const timeline = document.querySelector(".timeline-page body");

        timeline.addEventListener("wheel", (event) => {
            if (!event.deltaY) {
                return;
            }

            timeline.scrollLeft += event.deltaY;
        });

        // smooth scroll to all anchor links
        document
            .querySelectorAll('.timeline-page a[href^="#"]')
            .forEach((anchor) => {
                anchor.addEventListener("click", function (e) {
                    e.preventDefault();
                    let target;
                    if (this.id === "timeline-continue") {
                        target = document.querySelector(
                            "#timeline > ol > li:first-child"
                        );
                    } else {
                        target = document.querySelector(
                            `${this.getAttribute("href")} > li:first-child`
                        );
                    }
                    target.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "center",
                    });
                });
            });

        // observer on timeline items
        const timelineItems = document.querySelectorAll(".timeline-item");
        const formItems = document.querySelectorAll(".timeline-form");
        const visibleCls = "visible";

        const observerOptions = {
            threshold: 0.25,
            rootMargin: "0px",
        };

        const timelineItemsObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(visibleCls);
                } else {
                    entry.target.classList.remove(visibleCls);
                }
            });
        }, observerOptions);

        // observe on all elements
        if (timelineItems) {
            timelineItems.forEach((item) => {
                timelineItemsObserver.observe(item);
            });
        }
        if (formItems) {
            formItems.forEach((item) => {
                timelineItemsObserver.observe(item);
            });
        }

        // mobile year navigation
        const mobileYearNav = document.querySelector(
            ".timeline-nav__years.timeline-nav__years--mobile select"
        );
        mobileYearNav.addEventListener("change", () => {
            const target = document.querySelector(
                `#year-${mobileYearNav.value} > li:first-child`
            );
            target.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        });

        // videos
        document.addEventListener("click", (e) => {
            if (e.target.hasAttribute("data-play")) {
                const video = e.target.parentNode.querySelector("video");
                const img = e.target.parentNode.querySelector("img");
                video ? (video.style.display = "block") : null;
                img ? img.remove() : null;
                e.target.remove();
                video ? video.play() : null;
            }
        });
    }
}

module.exports = Timeline;
